import { render, staticRenderFns } from "./host-supply-buySupply.vue?vue&type=template&id=371104e9&scoped=true&"
import script from "./host-supply-buySupply.vue?vue&type=script&lang=js&"
export * from "./host-supply-buySupply.vue?vue&type=script&lang=js&"
import style0 from "./host-supply-buySupply.vue?vue&type=style&index=0&id=371104e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371104e9",
  null
  
)

export default component.exports